export const GET_SURVEYS = "GET_SURVEYS",
  SEND_SURVEYS = "SEND_SURVEYS";
